import Request from "@/common/net/request.js";
const request = new Request();
// 司机实时上报信息列表
export function getReportPage(data) {
  return request.send({
    url: `/pmy/sys/driver/monitor/report/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 司机实时上报信息总览
export function getReportOverview(data) {
  return request.send({
    url: `/pmy/sys/driver/monitor/report/overview`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 司机实时上报信息列表
export function getCarrierPage(data) {
  return request.send({
    url: `/pmy/sys/driver/monitor/carrier/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 司机实时承运状态--今日订单统计
export function getTodayOrderOverview(driverId) {
  return request.send({
    url: `/pmy/freight/order/freight/driver/today/overview?driverId=${driverId}`,
    method: "get"
  });
}

// 司机实时承运状态--今日订单列表
export function getTodayOrderPage(data) {
  return request.send({
    url: `/pmy/freight/order/freight/driver/today/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
